import { useQuery } from '@tanstack/react-query';

import { createApiClient } from 'lib/api/createApiClient';
import { useAuthStore } from 'lib/stores/authStore';
import config from 'utils/config';

export interface PortfolioBalanceResponse {
    balance: number;
    portfolio_value: number;
}

const api = createApiClient({
    baseURL: config.exchangeApiUrl,
});

export const getPortfolioBalance = async (signal?: AbortSignal): Promise<PortfolioBalanceResponse> => {
    const response = await api.get<PortfolioBalanceResponse>('/trade-api/v2/portfolio/balance', { signal });
    return response.data;
};

export const portfolioBalanceKeys = {
    all: ['portfolioBalance'] as const,
    user: (userId: string) => [...portfolioBalanceKeys.all, userId] as const,
};

interface UsePortfolioBalanceOptions {
    enabled?: boolean;
}

export const usePortfolioBalance = (userId: string | null, options?: UsePortfolioBalanceOptions) => {
    const isMember = useAuthStore((s) => s.isLoggedInMember);
    return useQuery({
        queryKey: portfolioBalanceKeys.user(userId ?? ''),
        queryFn: ({ signal }) => getPortfolioBalance(signal),
        enabled: !!userId && isMember && (options?.enabled ?? true),
        refetchInterval: config.midPollingInterval,
    });
};
